import React, { useState, useEffect } from 'react';

// 다국어
import { useTranslation } from 'react-i18next';
// @mui
import { styled } from '@mui/material/styles';
// Mui table
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import moment from 'moment';

import axios from 'axios';

import ProfileComponent from './ProfileComponent';

const StyledDiv = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '40px',
}));

const StyledDiv2 = styled('div')(() => ({
  backgroundColor: 'white',
  marginRight: '40px',
  padding: '30px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '10px',
  width: '20rem',
  height: '21rem',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
}));

const StyledDiv3 = styled('div')(() => ({
  backgroundColor: 'white',
  padding: '56px',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  borderRadius: '10px',
  '& h2': {
    marginBottom: '40px',
  },
}));

const StyledTableCell = styled(TableCell)(() => ({
  backgroundColor: 'white',
  borderTop: '1px solid #ddd',
  borderBottom: '1px solid #ddd',
  color: 'black',
}));

export default function LicenseManage({ data }) {
  // 다국어
  const { t, i18n } = useTranslation(['page']);

  useEffect(() => {
    const userData = JSON.parse(sessionStorage.getItem('login_info'));
    // 데이터 체크
    if (userData !== null) {
      axios
        .post(`${process.env.REACT_APP_SERVER_URL}/user/regist/${userData.user_token}`)
        .then((response) => {
          console.log(response.data[0][0]);
          if (!isEmptyArr(response.data[0])) {
            setAxiosData(response.data[0][0]);
            // 라이센스 타입별 사용횟수 검색
            axios({
              url: `${process.env.REACT_APP_SERVER_URL}/user/license-type/${response.data[0][0].type}`,
              method: 'post',
            })
              .then((response) => {
                // console.log("라이센스 타입 response", response.data[0][0])
                if (Object.prototype.hasOwnProperty.call(response.data[0][0], 'license_type_setting_json')) {
                  // console.log("라이센스 타입 json ", response.data[0][0])
                  console.log('라이센스 타입 response', JSON.parse(response.data[0][0].license_type_setting_json));
                  setLicenseTypeUseInfo(JSON.parse(response.data[0][0].license_type_setting_json));
                }
              })
              .catch((response) => {
                console.log(response);
              });
          } else if (isEmptyArr(response.data[0])) {
            setAxiosData({
              user_email: '',
              org_id: '',
              org_authority: '',
              org_status: 0,
              organization_name: '',
              organization_created_at: '',
              license_type: 'no license',
              license_due_date: null,
              license_enable: null,
              license_created_at: null,
              use_receipt_cnt: 0,
              available_receipt_cnt: 0,
              use_bill_cnt: 0,
              available_bill_cnt: 0,
              use_customer_cnt: 0,
              available_customer_cnt: 0,
              use_member_cnt: 0,
              available_member_cnt: 0,
              start_date: '',
              end_date: '',
            });
          }
        })
        .catch((response) => {
          console.log(response);
        });
      if (UserData.use_license !== 'N/A' && UserData.use_license !== null && UserData.use_license !== '') {
        getData();
      }
      // getAmountUsed(sendData,0);
      // getAmountUsed(sendData,1);
      // getAmountUsed(sendData,2);
      // const sendData = {
      //     user_token: UserData.user_token,
      //     month_count: 0,
      // }

      // axios({
      //     url: 'http://210.220.65.132:82/user/amount-used',
      //     method: 'post',
      //     data: sendData
      // }).then((response) => {

      //     if (Object.prototype.hasOwnProperty.call(response.data[0][0], 'type')) {
      //         setAmountUsedList(response.data[0][0])
      //     }

      // })
      //     .catch((response) => { console.log(response) })
    }
  }, []);

  // 들어온 배열이 빈값인지 확인하는 함수----------------------------------

  function isEmptyArr(arr) {
    if (Array.isArray(arr) && arr.length === 0) {
      return true;
    }
    return false;
  }

  // -------------------------------------------------------------------
  async function getData() {
    try {
      const result = await fetchAmountUsed();
      // console.log(result); // 출력 결과: Array(3)
      setAmountUsedList(result);
    } catch (error) {
      console.error(error);
    }
  }

  // async function fetchAmountUsed() {
  //     const sendData = {
  //       user_token: UserData.user_token,
  //     };

  //     const result = [];

  //     for (let i = 0; i < 3; i += 1) {
  //       sendData.month_count = i;

  //       try {
  //         const response = await axios({
  //           url: 'http://210.220.65.132:82/user/amount-used',
  //           method: 'post',
  //           data: sendData
  //         });

  //         // console.log(response.data[0][0]);

  //         if (Object.prototype.hasOwnProperty.call(response.data[0][0], 'type')) {
  //            console.log(response.data[0]);
  //           result.push(response.data[0]);
  //         } else if (Object.prototype.hasOwnProperty.call(response.data[0][0], 'err')) {
  //           // handle error
  //         }

  //       } catch (error) {
  //         console.log(error);
  //       }
  //     }

  //     return result;
  //   }

  async function fetchAmountUsed() {
    const sendData = {
      user_token: UserData.user_token,
    };

    const promises = Array.from({ length: 3 }, async (_, i) => {
      sendData.month_count = i;

      try {
        const response = await axios({
          url: `${process.env.REACT_APP_SERVER_URL}/user/amount-used`,
          method: 'post',
          data: sendData,
        });

        if (Object.prototype.hasOwnProperty.call(response.data[0][0], 'type')) {
          return response.data[0];
        }

        if (Object.prototype.hasOwnProperty.call(response.data[0][0], 'err')) {
          // handle error
          return null; // or another appropriate value
        }
      } catch (error) {
        console.log(error);
      }

      return null; // return null if 'type' or 'err' properties don't exist or an error is thrown
    });

    const results = await Promise.all(promises);

    return results.filter(Boolean); // Filter out any falsy values (like undefined)
  }

  // 테이블값 만들기
  function createData(plan, receipt, bill, vendors, groupMember, startDate, endDate) {
    return { plan, receipt, bill, vendors, groupMember, startDate, endDate };
  }

  const rows = [
    // createData(`${axiosData.license_type}`,
    //     `${axiosData.use_receipt_cnt}건/${axiosData.available_receipt_cnt}건`,
    //     `${axiosData.use_bill_cnt}건/${axiosData.available_bill_cnt}건`,
    //     `${axiosData.use_customer_cnt}개/${axiosData.available_customer_cnt}개`,
    //     `${axiosData.use_member_cnt}명/${axiosData.available_member_cnt}명`,
    //     `${axiosData.start_date}`,
    //     `${axiosData.end_date}`),
  ];

  // ---------------------------------------------------------

  // -----------------------------------------------------------

  const UserData = JSON.parse(sessionStorage.getItem('login_info'));
  const [axiosData, setAxiosData] = useState([]);
  const [amountUsedList, setAmountUsedList] = useState([]);
  const [licenseTypeUseInfo, setLicenseTypeUseInfo] = useState([]);
  console.log('axiosData', axiosData);

  return (
    <div style={{ display: 'flex', padding: '0 10%' }}>
      <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        <StyledDiv>
          <StyledDiv2>
            <ProfileComponent data={UserData} />
          </StyledDiv2>
          <StyledDiv3 style={{ flex: 1 }}>
            <h2>{t('라이센스 관리')}</h2>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <h3 style={{ marginBottom: '20px' }}>
                {t('현재')}
                <span style={{ color: 'rgb(26, 158, 248)', textDecoration: 'underline' }}>
                  {UserData.use_license === 'N/A' ? null : t(UserData.use_license)}
                </span>
                {UserData.use_license === 'N/A' ? t('이용중인 라이센스가 없습니다.') : t('라이센스 이용중입니다.')}
              </h3>
            </div>
            <div>
              <table>
                <tbody>
                  <tr>
                    <td width="160px" style={{ fontWeight: '900' }}>
                      <p>{t('서비스')}</p>
                    </td>
                    <td>{t(UserData.use_license)}</td>
                  </tr>
                  <tr>
                    <td width="160px" style={{ fontWeight: '900' }}>
                      {t('기간')}
                    </td>
                    {UserData.use_license === '레인드롭 무료 플랜' ? (
                      <td>{axiosData.license_created_at} ~ </td>
                    ) : (
                      <td>
                        {axiosData.start_date} ~ {axiosData.end_date}
                      </td>
                    )}
                  </tr>
                </tbody>
              </table>
            </div>
            <p style={{ margin: '30px 0 10px', fontWeight: '900' }}>{t('사용량(3개월)')}</p>

            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center">{t('접수')}</StyledTableCell>
                    <StyledTableCell align="center">{t('청구서')}</StyledTableCell>
                    <StyledTableCell align="center">{t('기간')}</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody style={{ borderBottom: '1px solid #ddd' }}>
                  {amountUsedList.length > 0 &&
                    amountUsedList.map((row, rowIndex) => (
                      <TableRow key={rowIndex}>
                        {row.map((column, columnIndex) => (
                          <TableCell key={columnIndex} align="center">
                            {columnIndex === row.length - 1
                              ? `${moment(column.start_date).format('YYYY-MM-DD')} ~ ${moment(column.last_date).format(
                                  'YYYY-MM-DD'
                                )} `
                              : column.type === 'reception_cnt'
                              ? `${column.count}건/${licenseTypeUseInfo.receipt_cnt}건`
                              : `${column.count}건/${licenseTypeUseInfo.bill_cnt}건`}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </StyledDiv3>
        </StyledDiv>
      </div>
    </div>
  );
}
